import $ from 'jquery'
import TableTooltip from '../../../controls/TableTooltip'
import {calculateTooltipOffset} from '../../../atBrowserUtils'
import TTDetailReportEditConfigController from './TTDetailReportEditConfigController'
import _ from 'underscore'

export default class TTDetailReportEditResultConfigController extends TTDetailReportEditConfigController {}

TTDetailReportEditResultConfigController.prototype.showErrorTooltip = function(event, error)
{
    TTDetailReportEditConfigController.prototype.showErrorTooltip.call(this, event, error);
    if (error === this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR)
        this.groupingLevelsSelectorErrorTooltipShown = true;
};

TTDetailReportEditResultConfigController.prototype.hideErrorTooltip = function()
{
    TTDetailReportEditConfigController.prototype.hideErrorTooltip.call(this);
    this.groupingLevelsSelectorErrorTooltipShown = false;
};

TTDetailReportEditResultConfigController.prototype.init = function ( config ) {
    TTDetailReportEditConfigController.prototype.init.call(this, config);

    const self = this;
    $("#joinCommentsInfoContainer").show();
    const icon = $("#joinCommentsInfo");
    const joinCommentsTooltip = new TableTooltip().init("joinCommentsTooltip");
    icon.hover(
        function(event) {
            if (self.groupingLevelsSelectorErrorTooltipShown)
            {
                self.errorTooltip.hide();
                self.errorTooltipTemporarilyHidden = true;
            }

            joinCommentsTooltip.show();
            joinCommentsTooltip.move(calculateTooltipOffset( joinCommentsTooltip, event ));
        },
        function(event) {
            joinCommentsTooltip.hide();

            if (self.groupingLevelsSelectorErrorTooltipShown && self.errorTooltipTemporarilyHidden)
            {
                self.errorTooltip.show();
                self.moveErrorTooltip(event);
                self.errorTooltipTemporarilyHidden = false;
            }
        }
    );
    
    icon.mousemove(
        function(event) {
            joinCommentsTooltip.move(calculateTooltipOffset( joinCommentsTooltip, event ));
            event.stopPropagation();
        }
    );
    
    return this;
};

TTDetailReportEditResultConfigController.prototype.makeReportParamsAccordingToFeatures = function( reportParameters ){
    return reportParameters;
};


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/ttDetail/TTDetailReportEditResultConfigController.js